"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceConfigSchema = exports.ConcentrationLimitCalculationSchema = exports.WeightingIterable = exports.LimitTypeIterable = exports.ResolvedConfigIterable = exports.SourceConfigIterable = exports.DeclarativeConfigIterable = void 0;
// Calculation main content (non-namespace exports)
const _imports_1 = require("../../_imports");
const Filters = __importStar(require("./Filters"));
exports.DeclarativeConfigIterable = [
    'weightedAverage',
    'standard',
    'exposureByGroup',
    'directInsert',
];
exports.SourceConfigIterable = [
    'pointer',
    ...exports.DeclarativeConfigIterable,
];
exports.ResolvedConfigIterable = [
    'resolvedPointer',
    ...exports.DeclarativeConfigIterable,
];
exports.LimitTypeIterable = ['min', 'max'];
exports.WeightingIterable = [
    'eligibleExposureLessConcentrationKickout',
    'constant',
];
// Zod schema for ConcentrationLimitCalculation (used in ReceivableResponseTape)
exports.ConcentrationLimitCalculationSchema = _imports_1.z.object({
    concentrationLimitKey: _imports_1.z.string(),
    concentrationLimit: _imports_1.z.number(),
    concentrationAmount: _imports_1.z.number().nullable().optional(),
    totalEligibleExposure: _imports_1.z.number(),
    concentration: _imports_1.z.number(),
    borrowingBaseReduction: _imports_1.z.number(),
    complianceStatus: _imports_1.ComplianceStatusSchema,
});
// ============= ZOD SCHEMAS =============
// Calculation filter schemas
const FilterCommonConfigSchema = _imports_1.z.object({
    applyToDenominator: _imports_1.z.boolean().optional(),
});
const OrderBySumConfigSchema = FilterCommonConfigSchema.extend({
    operation: _imports_1.z.literal('orderBySum'),
    field: _imports_1.z.string(),
    type: _imports_1.z.enum(['string', 'number']),
    groupBy: _imports_1.z.string(),
    count: _imports_1.z.number(),
    offset: _imports_1.z.number().optional(),
});
const OrderByConfigSchema = FilterCommonConfigSchema.extend({
    operation: _imports_1.z.literal('orderBy'),
    field: _imports_1.z.string(),
    count: _imports_1.z.number(),
    type: _imports_1.z.literal('number'),
    order: _imports_1.z.enum(Filters.OrderByOperatorIterable).optional(),
});
const InListConfigSchema = FilterCommonConfigSchema.extend({
    field: _imports_1.z.string(),
    operation: _imports_1.z.enum(Filters.InListConfigIterable),
    type: _imports_1.z.enum(['string', 'number', 'boolean']),
    list: _imports_1.z.array(_imports_1.z.any()).readonly(),
});
const EqualsConfigSchema = FilterCommonConfigSchema.extend({
    field: _imports_1.z.string(),
    operation: _imports_1.z.enum(Filters.EqualOperatorIterable),
    value: _imports_1.z.any(),
    type: _imports_1.z.enum(['string', 'number', 'boolean']),
});
const CompareNumbersConfigSchema = FilterCommonConfigSchema.extend({
    field: _imports_1.z.string(),
    operation: _imports_1.z.enum(Filters.CompareOperatorIterable),
    value: _imports_1.z.number(),
    type: _imports_1.z.literal('number'),
});
const FilterConfigSchema = _imports_1.z.union([
    OrderByConfigSchema,
    EqualsConfigSchema,
    OrderBySumConfigSchema,
    CompareNumbersConfigSchema,
    InListConfigSchema,
]);
// Calculation config schemas
const PointerConfigSchema = _imports_1.z.object({
    method: _imports_1.z.string(),
    filters: _imports_1.z.array(FilterConfigSchema).optional(),
});
const DeclarativeFilterWeightedAverageConfigSchema = _imports_1.z.object({
    field: _imports_1.z.string(),
    weighting: _imports_1.z.enum(exports.WeightingIterable),
    filters: _imports_1.z.array(FilterConfigSchema),
});
const DeclarativeFilterEligibleExposureBySingleFieldConfigSchema = _imports_1.z.object({
    groupingField: _imports_1.z.string(),
    fieldType: _imports_1.z.enum(['integer', 'string']),
    filters: _imports_1.z.array(FilterConfigSchema),
});
const DirectInsertConfigSchema = _imports_1.z.object({
    kickoutValueField: _imports_1.z.string(),
    filters: _imports_1.z.array(FilterConfigSchema),
});
const DeclarativeFilterStandardConfigSchema = _imports_1.z.object({
    filters: _imports_1.z.array(FilterConfigSchema),
});
// Calculation method config schemas (discriminated union on 'type')
const PointerMethodCalculationConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('pointer'),
    config: PointerConfigSchema,
});
const DeclarativeFilterWeightedAverageCalculationConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('weightedAverage'),
    limitType: _imports_1.z.enum(exports.LimitTypeIterable),
    config: DeclarativeFilterWeightedAverageConfigSchema,
});
const DeclarativeFilterStandardCalculationConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('standard'),
    config: DeclarativeFilterStandardConfigSchema,
});
const DeclarativeFilterEligibleExposureBySingleFieldCalculationConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('exposureByGroup'),
    config: DeclarativeFilterEligibleExposureBySingleFieldConfigSchema,
});
const DeclarativeDirectInsertConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('directInsert'),
    config: DirectInsertConfigSchema,
});
// Calculation.SourceConfig schema
exports.SourceConfigSchema = _imports_1.z.discriminatedUnion('type', [
    PointerMethodCalculationConfigSchema,
    DeclarativeFilterWeightedAverageCalculationConfigSchema,
    DeclarativeFilterStandardCalculationConfigSchema,
    DeclarativeFilterEligibleExposureBySingleFieldCalculationConfigSchema,
    DeclarativeDirectInsertConfigSchema,
]);
//# sourceMappingURL=Calculation.js.map